"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _draftJs = require("draft-js");

var _lib = require("../../../../lib");

var _Button = _interopRequireDefault(require("../../../Button"));

var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));

var _Container = _interopRequireDefault(require("../../../Container"));

var _Form = _interopRequireDefault(require("../../../Form"));

var _Icon = _interopRequireDefault(require("../../../Icon"));

var _Input = _interopRequireDefault(require("../../../Input"));

var _Label = _interopRequireDefault(require("../../../Label"));

var _Row = _interopRequireDefault(require("../../../Row"));

var _Tooltip = _interopRequireDefault(require("../../../Tooltip"));

require("./styles.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var LinkEntity =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LinkEntity, _PureComponent);

  function LinkEntity() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LinkEntity);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LinkEntity)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleCreateLink", function (e, _ref) {
      var title = _ref.title,
          target = _ref.url,
          shouldOpenNewTab = _ref.shouldOpenNewTab;
      (0, _lib.callEventMethods)(e, 'preventDefault');
      var editorState = _this.props.editorState; // open in new tab

      var linkProps = {
        url: target
      };

      if (shouldOpenNewTab) {
        linkProps.target = '_blank';
      } // create link entity key


      var entityKey = _lib.draft.createLinkEntityKey(editorState, linkProps); // append new text with link


      var contentWithTextLink = _lib.draft.replaceTextModifier(editorState, title, entityKey); // set new editor state


      var newEditorState = _draftJs.EditorState.set(editorState, {
        currentContent: contentWithTextLink
      });

      var _draft$extractEditorS = _lib.draft.extractEditorStateData(newEditorState, ['selection']),
          selection = _draft$extractEditorS.selection; // toggle link of new editor state


      newEditorState = _draftJs.RichUtils.toggleLink(newEditorState, selection, entityKey); // fix focus

      return _lib.draft.forceSelectionAppend(newEditorState, title.length);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnSubmit", function (e, data) {
      var newEditorState = _this.handleCreateLink(e, data);

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(newEditorState);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getData", function () {
      return {
        title: _this.getSelectedText(),
        url: _this.getCurrentURL()
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedText", function () {
      var editorState = _this.props.editorState;

      var _draft$extractEditorS2 = _lib.draft.extractEditorStateData(editorState, ['selection']),
          selection = _draft$extractEditorS2.selection;

      var _draft$extractSelecti = _lib.draft.extractSelectionStateData(selection, ['isCollapsed']),
          isCollapsed = _draft$extractSelecti.isCollapsed;

      if (!isCollapsed) {
        return _lib.draft.getSelectedText(editorState);
      }

      return '';
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentURL", function () {
      var editorState = _this.props.editorState;

      var _draft$extractEditorS3 = _lib.draft.extractEditorStateData(editorState, ['content', 'selection']),
          content = _draft$extractEditorS3.content,
          selection = _draft$extractEditorS3.selection;

      var _draft$extractSelecti2 = _lib.draft.extractSelectionStateData(selection, ['startKey', 'startOffset']),
          startKey = _draft$extractSelecti2.startKey,
          startOffset = _draft$extractSelecti2.startOffset;

      var _draft$extractContent = _lib.draft.extractContentStateData(content, [{
        key: 'blockForKey',
        value: startKey
      }]),
          blockWithLinkAtBeginning = _draft$extractContent.blockForKey;

      var _draft$extractContent2 = _lib.draft.extractContentBlockData(blockWithLinkAtBeginning, [{
        key: 'entity',
        value: startOffset
      }]),
          linkKey = _draft$extractContent2.entity;

      var url = '';

      if (linkKey) {
        var _draft$extractContent3 = _lib.draft.extractContentStateData(content, [{
          key: 'entity',
          value: linkKey
        }]),
            linkInstance = _draft$extractContent3.entity;

        var _linkInstance$getData = linkInstance.getData();

        url = _linkInstance$getData.url;
      }

      return url;
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [LinkEntity.className];
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "renderTitle", function (_ref2) {
      var name = _ref2.name,
          value = _ref2.value,
          onChange = _ref2.onChange;
      return _react["default"].createElement(_Label["default"], {
        content: "Link Title"
      }, _react["default"].createElement(_Input["default"], {
        fluid: true,
        name: name,
        value: value,
        onChange: onChange
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderURL", function (_ref3) {
      var name = _ref3.name,
          value = _ref3.value,
          onChange = _ref3.onChange;
      return _react["default"].createElement(_Label["default"], {
        content: "Link URL"
      }, _react["default"].createElement(_Input["default"], {
        fluid: true,
        name: name,
        value: value,
        onChange: onChange
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderOpenInNewTabCheckbox", function (_ref4) {
      var name = _ref4.name,
          value = _ref4.value,
          _onChange = _ref4.onChange;
      return _react["default"].createElement(_Label["default"], null, _react["default"].createElement(_Checkbox["default"], {
        special: true,
        fluid: true,
        name: name,
        onChange: function onChange(e, _ref5) {
          var checked = _ref5.checked;
          return _onChange(e, {
            name: name,
            value: checked
          });
        },
        checked: value
      }, "Open URL in new tab"));
    });

    _defineProperty(_assertThisInitialized(_this), "renderButtons", function (_ref6, close) {
      var hasRequiredData = _ref6.hasRequiredData,
          onClear = _ref6.onClear,
          onSubmit = _ref6.onSubmit;
      return _react["default"].createElement(_Row["default"], {
        between: true
      }, _react["default"].createElement(_Button["default"], {
        outline: true,
        color: "blue",
        onClick: function onClick(e) {
          onClear(e);
          onSubmit(e);
          close(e);
        },
        disabled: !hasRequiredData
      }, "Add"), _react["default"].createElement(_Button["default"], {
        color: "blue",
        onClick: function onClick(e) {
          onClear(e);
          close(e);
        }
      }, "Cancel"));
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function (_ref7) {
      var close = _ref7.close;

      var data = _this.getData();

      return _react["default"].createElement(_Container["default"], {
        basic: true,
        noContent: true,
        style: {
          minWidth: '15rem',
          padding: '1.5rem'
        }
      }, _react["default"].createElement(_Form["default"], {
        as: "div",
        data: data,
        onSubmit: _this.handleOnSubmit,
        submitAll: true
      }, _react["default"].createElement(_Form["default"].Field, {
        name: "title",
        required: true
      }, _this.renderTitle), _react["default"].createElement(_Form["default"].Field, {
        name: "url",
        required: true
      }, _this.renderURL), _react["default"].createElement(_Form["default"].Field, {
        name: "shouldOpenNewTab"
      }, _this.renderOpenInNewTabCheckbox), _react["default"].createElement(_Form["default"].Consumer, null, function (formProps) {
        return _this.renderButtons(formProps, close);
      })));
    });

    return _this;
  }

  _createClass(LinkEntity, [{
    key: "render",
    value: function render() {
      var classNames = this.classNames();
      return _react["default"].createElement(_Tooltip["default"], {
        basic: true,
        contentClassName: classNames,
        content: this.renderContent
      }, function (_ref8) {
        var open = _ref8.open,
            visible = _ref8.visible;
        return _react["default"].createElement(_Button["default"], {
          className: "MHub-RichTextEditor-Controls",
          key: "Link",
          title: "Link",
          basic: true,
          color: visible ? 'white' : null,
          icon: _react["default"].createElement(_Icon["default"].Link, null),
          onClick: open
        });
      });
    }
  }]);

  return LinkEntity;
}(_react.PureComponent);

exports["default"] = LinkEntity;

_defineProperty(LinkEntity, "className", 'MHub-RichTextEditor-Link-Entity');

_defineProperty(LinkEntity, "propTypes", {
  editorState: _propTypes["default"].instanceOf(Object).isRequired,
  onChange: _propTypes["default"].func
});

_defineProperty(LinkEntity, "defaultProps", {
  onChange: null
});